import React from 'react';
import { Combo } from '@fx-ui/fine-design';
import { map } from '@libs/shared';
import { PersonaCustomComponent, PersonaInfo } from '~/interfaces';
import { getCurrentLocaleKey } from '~/utils';
import PersonaCollectItem from '../persona-collect-item';
import { LOCALE_KEY } from '@fx-ui/intl';

interface CustomComponentsProps {
    components: PersonaCustomComponent[];
    data: PersonaInfo['suiteCustomData'];
    onChange: (key: string, value: string | string[]) => void;
}

/** 自定义画像字段 */
const CustomComponents: React.FC<CustomComponentsProps> = ({ components, data, onChange }) => {
    const currentLocaleKey = getCurrentLocaleKey();

    const renderComponent = (component: PersonaCustomComponent) => {
        const componentKey = component.key;
        const value = data?.[componentKey];

        const comboCommonProps = {
            className: 'custom-component-combo',
            hasSearch: false,
            hasClear: false,
            style: { width: '100%' },
            placeholder:
                component.placeholder?.[currentLocaleKey] ||
                component.placeholder?.[LOCALE_KEY.ZH_CN],
            items: map(component.options, (option) => ({
                value: option.value,
                text: option.label[currentLocaleKey] || option.label[LOCALE_KEY.ZH_CN]!
            }))
        };

        switch (component.type) {
            case 'combo': {
                return (
                    <Combo
                        {...comboCommonProps}
                        value={value as string}
                        onChange={(nextValue: string) => {
                            onChange(componentKey, nextValue);
                        }}
                    />
                );
            }
            case 'combo-check': {
                return (
                    <Combo.Check
                        {...comboCommonProps}
                        value={value as string[]}
                        onChange={(nextValue: string[]) => {
                            onChange(componentKey, nextValue);
                        }}
                    />
                );
            }
        }
    };

    return (
        <>
            {map(components, (component) => {
                return (
                    <PersonaCollectItem
                        className="fx-custom-component"
                        key={component.key}
                        title={
                            component.label[currentLocaleKey] || component.label[LOCALE_KEY.ZH_CN]
                        }
                    >
                        {renderComponent(component)}
                    </PersonaCollectItem>
                );
            })}
        </>
    );
};

export default CustomComponents;
